/// <reference types="vite/client" />
// import '@fontsource-variable/montserrat';
import '@fontsource-variable/inter';
import { QueryClient } from '@tanstack/react-query';
import { HeadContent, Outlet, Scripts, createRootRouteWithContext } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import * as React from 'react';
import { DefaultCatchBoundary } from '~/components/DefaultCatchBoundary';
import { AppStartup } from '~/components/layout/app-startup';
import { NotFound } from '~/components/NotFound';
import { SidebarProvider, ThemeProvider } from '~/context';
import AuthGuard from '~/features/auth/auth-guard';
import { MediaQueryProvider, NextUiProvider, QueryProvider } from '~/providers';
import { ProcessProvider } from '~/providers/process-provider';
import type { AuthState } from '~/stores/auth-store';
import appCss from '~/styles/app.css?url';
import mainCss from '~/styles/main.scss?url';
import splashCss from '~/styles/app-splash.css?url';
import { seo } from '~/utils/seo';
import { AnythingLLMChat } from '~/components/AnythingLLMChat';
const BASE_URL = import.meta.env.VITE_BASE_URL;
export const Route = createRootRouteWithContext<{
	auth: AuthState;
	queryClient: QueryClient;
}>()({
	head: () => ({
		meta: [
			{
				charSet: 'utf-8',
			},
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1',
			},
			...seo({
				title: 'Samtek One - Nâng tầm kênh phân phối',
				description: `Samtek One là nền tảng công nghệ số hóa kênh phân phối, tối ưu chi phí và hiệu suất bán hàng từ nhóm nhỏ đến doanh nghiệp, linh hoạt mọi lĩnh vực.`,
				image: `${BASE_URL}/images/og-img.png`,
			}),
		],
		links: [
			{ rel: 'stylesheet', href: appCss },
			{ rel: 'stylesheet', href: mainCss },
			{ rel: 'stylesheet', href: splashCss },
			{ rel: 'preload', as: 'image', href: '/images/logo.png' },
			// { rel: "manifest", href: "/site.webmanifest", color: "#fffff" },
			{ rel: 'icon', href: '/favicon.ico' },
		],
	}),
	errorComponent: (props) => {
		return (
			<RootDocument>
				<DefaultCatchBoundary {...props} />
			</RootDocument>
		);
	},
	notFoundComponent: () => <NotFound />,
	component: RootComponent,
});

function RootComponent() {
	return (
		<RootDocument>
			<Outlet />
		</RootDocument>
	);
}

function RootDocument({ children }: { children: React.ReactNode }) {
	return (
		<html lang="vi">
			<head>
				<HeadContent />
				<meta name="google" content="notranslate" />
			</head>
			<body className="font-montserrat">
				<NextUiProvider>
					<ThemeProvider>
						<QueryProvider>
							<AppStartup>
								<MediaQueryProvider>
									<AuthGuard>
										<ProcessProvider>
											<SidebarProvider>{children}</SidebarProvider>
										</ProcessProvider>
									</AuthGuard>
								</MediaQueryProvider>
							</AppStartup>
						</QueryProvider>
					</ThemeProvider>
				</NextUiProvider>
				{/* <AnythingLLMChat /> */}
				{/* <TanStackRouterDevtools position="bottom-right" /> */}
				<Scripts />
				{/* AnythingLLM Samtek One Chat Widget */}
				{/* <script
					data-embed-id="4c52cf98-6707-477b-9f87-d2e2824441b1"
					data-base-api-url="http://180.93.114.59:3001/api/embed"
					data-assistant-name="Samtek One"
					src="http://180.93.114.59:3001/embed/anythingllm-chat-widget.min.js"
				/>
				<script
					dangerouslySetInnerHTML={{
						__html: `
(function() {
	var customLogoUrl = "https://one.samtek.vn/upload/beta/samtek/logo/white_logo_v01.png";
	var observer = new MutationObserver(function() {
		var images = document.querySelectorAll('img');
		images.forEach(function(img) {
			if (!img.src.includes('one.samtek.vn') && (img.src.includes('anythingllm') || img.closest('[id*="chat"]') || img.closest('[class*="chat"]'))) {
				if (img.src !== customLogoUrl) {
					img.src = customLogoUrl;
					img.srcset = customLogoUrl;
					img.style.objectFit = "contain";
					img.style.backgroundColor = "#222";
					img.style.borderRadius = "50%";
				}
			}
		});

		var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
		while(walker.nextNode()) {
			var node = walker.currentNode;
			if (node.nodeValue && (node.nodeValue.includes('Powered by') || node.nodeValue.includes('AnythingLLM'))) {
				var parent = node.parentElement;
				if (parent) {
					parent.style.display = 'none';
				}
			}
		}
	});

	if (document.body) {
		observer.observe(document.body, { childList: true, subtree: true });
	} else {
		document.addEventListener('DOMContentLoaded', function() {
			observer.observe(document.body, { childList: true, subtree: true });
		});
	}
})();
						`,
					}}
				/> */}
			</body>
		</html>
	);
}
